import instance from "../axiosConfig";
import { Template, TemplateContent } from "./models";

export class TemplateService {
    private regionCode: string;

    constructor(regionCode: string) {
        this.regionCode = regionCode;
    }

    getTemplates = async (): Promise<Template[]> => {
        const response = await instance.get<Template[]>(`api/admin/${this.regionCode}/templates`);

        return response.data;
    };

    createTemplate = async (name: string): Promise<Template> => {
        const response = await instance.post<Template>(`api/admin/${this.regionCode}/templates`, {
            name,
        });

        return response.data;
    };

    getTemplate = async (templateId: string): Promise<Template | undefined> => {
        const response = await instance.get<Template>(`api/admin/${this.regionCode}/templates/${templateId}`);

        if (response.status === 404) return undefined;

        return response.data;
    };

    updateTemplate = async (templateId: string, name: string): Promise<Template> => {
        const response = await instance.put<Template>(
            `api/admin/${this.regionCode}/templates/${templateId}`,
            {
                name,
            },
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        return response.data;
    };

    deleteTemplate = async (templateId: string): Promise<boolean> => {
        try {
            const response = await instance.delete<Template>(`api/admin/${this.regionCode}/templates/${templateId}`);

            return response.status >= 200 && response.status < 300;
        } catch {
            return false;
        }
    };

    getTemplateContent = async (templateId: string, languageCode: string): Promise<TemplateContent | undefined> => {
        const response = await instance.get<TemplateContent>(
            `api/admin/${this.regionCode}/templates/${templateId}/languages/${languageCode}`
        );

        if (response.status === 404) return undefined;

        const templateContent = response.data;
        const contentOrder = JSON.parse(templateContent.content) || [];

        templateContent.sections.sort((a, b) => {
            const indexA = contentOrder.indexOf(a.sectionCode);
            const indexB = contentOrder.indexOf(b.sectionCode);

            return indexA - indexB;
        });

        return templateContent;
    };

    createTemplateContent = async (
        templateId: string,
        languageCode: string,
        content: TemplateContent
    ): Promise<TemplateContent> => {
        const response = await instance.post<TemplateContent>(
            `api/admin/${this.regionCode}/templates/${templateId}/languages/${languageCode}`,
            content
        );

        return response.data;
    };

    updateTemplateContent = async (
        templateId: string,
        languageCode: string,
        content: TemplateContent
    ): Promise<TemplateContent> => {
        const response = await instance.put<TemplateContent>(
            `api/admin/${this.regionCode}/templates/${templateId}/languages/${languageCode}`,
            content,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        return response.data;
    };

    deleteTemplateContent = async (templateId: string, languageCode: string): Promise<boolean> => {
        const response = await instance.delete<Template>(
            `api/admin/${this.regionCode}/templates/${templateId}/languages/${languageCode}`
        );

        return response.status >= 200 && response.status < 300;
    };
}
